import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {Link} from "react-router-dom";
import {Typography} from "@mui/material";
import PrettyBox from "../PrettyBox/PrettyBox.tsx";
import './Khoddam.scss';
import p1 from "../../assets/icons2/c657cc0c-284e-4292-81bc-e1c7dc79ceff.png";
import p2 from "../../assets/icons2/a24d0c4c-ef6a-4adb-b92d-9f186760ed5e.png";
import NewsList from "../NewsList/NewsList.tsx";
import {useState} from "react";
import RegUser from "../regUser/RegUser.tsx";
import HadisBox from "../HadisBox/HadisBox.tsx";
import IranSanse from "../Typography/IranSanse.tsx";


let TopMenu =
    [
        {
            "id": "5f8a3530-dff1-4801-8723-bed5d0b74dcf",
            "title": "اخبار خدام",
            "link": "news",
            "iconId": p1,
            "parentId": null,
            "order": "2",
            "isActive": true
        },
        {
            "id": "98cbfe71-6392-40a5-adf1-b26399c6a32b",
            "title": "ثبت نام",
            "link": "register",
            "iconId": p2,
            "parentId": null,
            "order": "3",
            "isActive": true
        }
    ]
export default function () {
    const [current, setCurrent] = useState('')

    return <>
        <Row className='g-0'>
            <Col>
                <PrettyBox Width={'100%'} Height={'120px'}>
                    <Row className="g-0 pb-3 pt-4 mx-0 d-flex justify-content-center"
                         style={{width: '100%'}}>
                        {
                            TopMenu.map(menu => {
                                return (
                                    <Col key={menu.id}
                                         className="  text-center  mx-0 px-0">
                                        <Row className="g-0">
                                            <div onClick={() => {
                                                setCurrent(menu.link)
                                            }}
                                                 className="mx-0 px-0">
                                                <Col className="d-flex justify-content-center">
                                                    <div
                                                        className={"footerMenuBox22"}>
                                                        <img src={menu.iconId} alt=""/>
                                                    </div>
                                                </Col>
                                            </div>
                                        </Row>
                                        <Row className='footerText text-muted text-center g-0'>
                                            <Col className='text-center pt-2'>
                                                <Typography fontSize={12}
                                                            fontFamily={'iranSanse-medium'}>{menu.title}</Typography>
                                            </Col>
                                        </Row>
                                    </Col>

                                )
                            })
                        }
                    </Row>
                </PrettyBox>
            </Col>
        </Row>
        <Row className='g-0'>
            <Col>
                {current === 'news' ?
                    <NewsList current='Khoddam'></NewsList> :
                    current === 'register' ?
                        <RegUser/> :
                        <HadisBox>
                            <IranSanse>شرایط ثبت نام خدام</IranSanse>
                        </HadisBox>
                }
            </Col>
        </Row>
    </>
}